package com.shadowings.gero.domain.model

data class VerbSentence(
    val hieroglyphs: String,
    val sentence: String,
    val transliteration: String
)